

  export async function uploadUnexpectedStockOutflowFile(repository, file) {
    if (!file) {
      throw new Error('El archivo es requerido')
    }

    return repository.upload(file)
  }
